import React, { ReactNode } from "react"

const elementSplitter = (children: React.ReactElement) => {
  //
  // Filter Elements
  const filterElement = (child: React.ReactNode, element: Array<string>) =>
    React.isValidElement(child) &&
    typeof child.type === "string" &&
    element.includes(child.type)

  // Check Br After Element
  const checkBrAfterElement = (
    child: React.ReactNode,
    index: number,
    array: Array<ReactNode>
  ) => {
    const previousElement = array[index - 1]
    return (
      filterElement(child, ["br"]) &&
      (filterElement(previousElement, ["p"]) ||
        filterElement(previousElement, ["br"]))
    )
  }

  // Filter Extension
  const filterExtension = (child: React.ReactNode, extension: string) =>
    React.isValidElement(child) && child.props.src.endsWith(extension)

  // Filter Typeof
  const filterTypeof = (child: React.ReactNode, type: string) =>
    React.isValidElement(child) && typeof child.type === type

  /////////////////////////////////////////////////////////////////////

  // Headers
  const headers = React.Children.toArray(children).filter(
    (child, index, array) =>
      filterElement(child, ["h1", "h2", "h3", "h4", "h5", "h6"]) ||
      checkBrAfterElement(child, index, array)
  ) as React.ReactElement[]

  // Paragraphs
  const paragraphs = React.Children.toArray(children).filter(
    (child, index, array) =>
      filterElement(child, ["p"]) || checkBrAfterElement(child, index, array)
  ) as React.ReactElement[]

  // Spans
  const spans = React.Children.toArray(children).filter(
    (child, index, array) =>
      filterElement(child, ["span"]) || checkBrAfterElement(child, index, array)
  ) as React.ReactElement[]

  // Images
  const images = React.Children.toArray(children).filter(
    child => filterElement(child, ["img"]) && filterExtension(child, ".webp")
  ) as React.ReactElement[]

  // SVGs
  const svgs = React.Children.toArray(children).filter(
    child => filterElement(child, ["img"]) && filterExtension(child, ".svg")
  ) as React.ReactElement[]

  // components
  const components = React.Children.toArray(children).filter(
    (child, index, array) =>
      filterTypeof(child, "function") ||
      filterElement(child, ["div"]) ||
      checkBrAfterElement(child, index, array)
  ) as React.ReactElement[]

  // Links
  const links = React.Children.toArray(children).filter(
    (child, index, array) =>
      filterElement(child, ["a"]) || checkBrAfterElement(child, index, array)
  ) as React.ReactElement[]

  /////////////////////////////////////////////////////////////////////

  return { headers, paragraphs, spans, images, svgs, components, links }
}

export default elementSplitter
